import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationHistoryService implements OnDestroy {
  private readonly history: string[] = [];
  private routerEventsSubscription: Subscription | undefined;

  constructor(
    private readonly router: Router,
  ) { }

  init() {
    this.routerEventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if(this.history.length > 0 && this.history[this.history.length - 1] === event.urlAfterRedirects) {
          return;
        }
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  getHistoryNavigation(): string[] {
    return [...this.history];
  }

  ngOnDestroy(): void {
    this.routerEventsSubscription?.unsubscribe();
  }

  public goBack(stepBack: number = 1): void {
    this.history.splice(-stepBack);
    if (this.history.length > 0) {
      this.router.navigateByUrl(this.history[this.history.length - 1]);
    } else {
      this.router.navigateByUrl('/').then(() => { });
    }
  }

  public getPreviousPath(): string | undefined {
    return this.history.at(this.history.length - 2);
  }

  public popLastPath(): string | undefined {
    return this.history.pop();
  }
}
